export default "__VITE_ASSET__DJoF6Ppl__"